import { render, staticRenderFns } from "./ChallengePartnerForm.vue?vue&type=template&id=028c68d9&scoped=true&"
import script from "./ChallengePartnerForm.vue?vue&type=script&lang=js&"
export * from "./ChallengePartnerForm.vue?vue&type=script&lang=js&"
import style0 from "./ChallengePartnerForm.vue?vue&type=style&index=0&id=028c68d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028c68d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src469726766/src/admin-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('028c68d9')) {
      api.createRecord('028c68d9', component.options)
    } else {
      api.reload('028c68d9', component.options)
    }
    module.hot.accept("./ChallengePartnerForm.vue?vue&type=template&id=028c68d9&scoped=true&", function () {
      api.rerender('028c68d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/ChallengePartnerForm.vue"
export default component.exports